/** @module csi/heading/AttributeEdit */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/xml",
	"csi/def/ViewRef",
	"csi/heading/AttributeAction"
], function(declare,lang,def,xml,ViewRef,AttributeAction) {

	return declare(AttributeAction, {
		constructor: function(obj) {
			this.m_tag = "Edit";
			this.m_viewRef = lang.mixin(new ViewRef(), {m_id: def.DEFAULT_FORM_ID});
			this.setBaseRights(xml.RIGHT_WRITE);
		},
		
		/**
		 * Return false so this action to popup Edit form is in tooltip
		 */
		canBeInlined: function() {
			return false;
		}
	});
});